// extracted by mini-css-extract-plugin
export default {"chefs":"chefs_chefs__enwS8","social":"chefs_social__9GRlK","chefMember":"chefs_chefMember__9E2Y-","memberImg":"chefs_memberImg__BodDA"};